import axios from '../plugins/axios';

const COMMON_REQUEST_HEADER = {
  'Content-Type': 'application/json',
};

export default {
  getContractManagerPermission() {
    const url = process.env.VUE_APP_HIWORKS_CONTRACT_HR_API + `/managers/check`;
    const options = {
      headers: COMMON_REQUEST_HEADER,
      withCredentials: true,
    };

    return axios.get(url, options);
  },
  getPayrollManagerPermission() {
    const url = process.env.VUE_APP_HIWORKS_PAYROLL_HR_API + `/managements/managers/check`;
    const options = {
      headers: COMMON_REQUEST_HEADER,
      withCredentials: true,
    };

    return axios.get(url, options);
  },

  getInsaManagerPermission() {
    const url = process.env.VUE_APP_HIWORKS_HR_API + `/my-perm`;
    const options = {
      headers: COMMON_REQUEST_HEADER,
      withCredentials: true,
    };

    return axios.get(url, options);
  },

  getPosition(id) {
    if (!id) {
      throw new Error('not exist id value');
    }

    let url = process.env.VUE_APP_HIWORKS_HR2_API + `/positions?filter[id]=${id}`;

    const options = {
      headers: COMMON_REQUEST_HEADER,
      withCredentials: true,
    };

    return axios.get(url, options);
  },
};
